import type { QueryClient } from '@tanstack/react-query'

/** Refresh what setting a recipe up, changing or removing it changes. */
export function invalidateRecipes(qc: QueryClient, workspaceId: string) {
  void qc.invalidateQueries({ queryKey: ['recipe-installs', workspaceId] })
  void qc.invalidateQueries({ queryKey: ['recipes', workspaceId] })
  void qc.invalidateQueries({ queryKey: ['topics', workspaceId] })
  // What it creates are route and workflow resources; a source's own row
  // can change too (a webhook's normalize fragment).
  void qc.invalidateQueries({ queryKey: ['resources'] })
  void qc.invalidateQueries({ queryKey: ['resource', 'detail'] })
}
